import Vue from 'vue'
import App from './App'
import router from './router'
import store from './state/store'

import BootstrapVue from 'bootstrap-vue'

import globals from './globals'
import Popper from 'popper.js'
import FrechmannAPI from './lib/api'

/* NUMERALS */
var numeral = require('numeral')
require('numeral/locales/de')
numeral.locale('de')
numeral.localeData('de').delimiters.thousands = '.'
Vue.filter('formatCurrency', function (value) {
    return numeral(value).format('0.00')
})

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))

// Global RTL flag
Vue.mixin({
    data: globals,
    methods: {
        formatInputNumber: function (str) {
            if (typeof str !== 'string') {
                return str
            } else {
                return str.replace(',', '.')
            }
        }
    }
})

Vue.API = new FrechmannAPI('http://www.frechmann.com/php')

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
